export default "__VITE_ASSET__RJ2IZ1HH__"